// src/pages/Auth/PaymentCancel.js
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from "../../components/ui/button";
import { X, ArrowLeft, RefreshCw } from "lucide-react";

const PaymentCancel = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gradient-to-br from-red-50 to-orange-50 flex items-center justify-center p-4">
      <div className="max-w-md w-full bg-white rounded-2xl shadow-xl p-8 text-center">
        <div className="mb-6 flex justify-center">
          <div className="w-20 h-20 bg-red-100 rounded-full flex items-center justify-center">
            <X className="w-12 h-12 text-red-600" />
          </div>
        </div>
        
        <h1 className="text-3xl font-bold text-gray-900 mb-4">
          Payment Cancelled
        </h1>
        
        <p className="text-gray-600 mb-8">
          Your payment was cancelled. Don't worry, no charges were made to your account.
        </p>

        <div className="space-y-3">
          <Button
            onClick={() => navigate('/get-started')}
            className="w-full bg-blue-600 hover:bg-blue-700"
            size="lg"
          >
            <RefreshCw className="mr-2 h-4 w-4" />
            Try Again
          </Button>

          <Button
            onClick={() => navigate('/')}
            variant="outline"
            className="w-full"
            size="lg"
          >
            <ArrowLeft className="mr-2 h-4 w-4" />
            Back to Home
          </Button>
        </div>

        <div className="mt-8 pt-6 border-t border-gray-200">
          <p className="text-sm text-gray-600 mb-4">
            Need help? Contact our support team
          </p>
          <Button
            onClick={() => navigate('/legal/contact-us')}
            variant="ghost"
            size="sm"
          >
            Contact Support
          </Button>
        </div>
      </div>
    </div>
  );
};

export default PaymentCancel;

